import _ from 'lodash';
import Parameter from './Parameter';
import Disease from './Disease';
import Hatchery from './Hatchery';
import BroodStockProduct from './BroodStockProduct';
import Laboratory from './Laboratory';
import Farm from './Farm';
import FarmParameter from './FarmParameter';
import FarmUser from './FarmUser';
import Pond from './Pond';
import AutoFeederPond from "./AutoFeederPond"
import MultiMeasurement from './MultiMeasurement';
import Measurement from './Measurement';
import Treatment from './Treatment';
import Cycle from './Cycle';
import Batch from './Batch';
import CycleActual from './CycleActual';
import CyclePrediction from './CyclePrediction';
import Feed from './Feed';
import Fasting from './Fasting';
import Sampling from './Sampling';
import Harvest from './Harvest';
import Mortality from './Mortality';
import CycleDisease from './CycleDisease';
import File from './File';
import Region from './Region';
import Country from './Country';
import Product from './Product';
import Stock from './Stock';
import User from './User';
import FeedingTrayControl from './FeedingTrayControl';
import Currency from './Currency';
import Species from './Species';
import Notification from './Notification';
import Widget from './Widget';

import Activity from './Activity';
import FarmShrimpPrice from './FarmShrimpPrice';
import ShrimpPrice from './ShrimpPrice';
import CycleToDo from './CycleToDo';
import Simulation from './Simulation';
import SyncableModel from "./SyncableModel"
import { createAxios } from '../utils/axios';
import moment from 'moment';

export {
  Parameter,
  Disease,
  BroodStockProduct,
  Hatchery,
  Laboratory,
  Farm,
  FarmParameter,
  FarmUser,
  Pond,
  AutoFeederPond,
  Cycle,
  Batch,
  MultiMeasurement,
  Measurement,
  Treatment,
  CycleActual,
  CyclePrediction,
  Feed,
  Fasting,
  Sampling,
  Harvest,
  Mortality,
  CycleDisease,
  File,
  Region,
  Country,
  Product,
  Stock,
  User,
  FeedingTrayControl,
  Currency,
  Species,
  Notification,
  Widget,

  Activity,
  FarmShrimpPrice,
  ShrimpPrice,
  CycleToDo,
  Simulation
};

export const initialSyncAllModels = [
  Region,
  Species,
  Currency,
  Parameter,
  Hatchery,
  Laboratory,
  Product,
  Farm,
  User,
  FarmParameter,
  FarmUser,
  Stock,
  Pond,
  AutoFeederPond,
  Cycle,
];

// export const initialSyncAllModelsFarmSupport = [
//   Region,
//   Farm,
//   User,
// ];

export const initialSyncFarms = [
  Region, // syncAll
  Species,
  Parameter,
  Laboratory,
  Product,
  Currency,
  Hatchery,
  Farm,
  User, // syncAll
  FarmParameter,
  FarmUser,
  Stock,
  Pond,
  AutoFeederPond,
  Cycle,
]

export function initialSyncAll(
  onSyncProgressUpdate = undefined, onError = undefined
) {
  let promise = Promise.resolve(true);
  SyncableModel.allowReplaceUpdate = true;
  const progresses = [];
  const total = initialSyncAllModels.length;
  initialSyncAllModels.forEach((initialSyncAllModel, index) => {
    promise = promise.then((success) => {
      let ECONNABORTED = false;
      const syncAll = () => initialSyncAllModel.syncAll({}, [], true, (p) => {
        progresses[index] = p;
        if (onSyncProgressUpdate) {
          onSyncProgressUpdate(_.sum(progresses) / total, total, _.sum(progresses) / 100 / total);
        }
      }, (error) => {
        if (error.code === 'ECONNABORTED') ECONNABORTED = true
        if (onError) onError(error);
        return false;
      }).then((s) => {
        if (!s && ECONNABORTED) return syncAll()
        return s
      })
      return success && syncAll()
    });
  });
  return promise.then((success) => {
    if (success && onSyncProgressUpdate) onSyncProgressUpdate(100);
    return success
  }).finally(() => {
    SyncableModel.allowReplaceUpdate = false
  });
}

export async function initialSyncAllV2(
  onSyncProgressUpdate = undefined, onError = undefined
) {
  let promise = Promise.resolve(true);
  SyncableModel.allowReplaceUpdate = true;
  const progresses = [];
  const total = initialSyncFarms.length;
  const timestamp = moment().utc().format('YYYY-MM-DD HH:mm:ss')
  const bulkData = await createAxios().get("/profile", {
    params: {
      with: 'species,farms,parameters,hatcheries,laboratories,products_has_stocks,farm_parameters,all_farm_users,stocks,ponds,auto_feeder_ponds,cycles,currencies'
    }
  }).then((response) => {
    const data = response.data?.data || {}
    
    return {
      // 'Region': data?.regions || [],
      'Species': data?.species || [],
      'Parameter': data?.parameters || [],
      'Laboratory': data?.laboratories || [],
      'Product': data?.products_has_stocks || [],
      'Currency': data?.currencies || [],
      'Hatchery': data?.hatcheries || [],
      'Farm': data?.farms || [],
      // 'User':  data?.users || [],
      'FarmParameter': data?.farm_parameters || [],
      'FarmUser': data?.all_farm_users || [],
      'Stock': data?.stocks || [],
      'Pond': data?.ponds || [],
      'AutoFeederPond': data?.auto_feeder_ponds || [],
      'Cycle': data?.cycles || [],
    }
  })
  bulkData[User.name] = await createAxios().get('/users', {
    params: { per_page: 1000, has: 'farms.farm_user' }
  }).then((response) => response.data?.data || [])
  initialSyncFarms.forEach((initialSyncAllModel, index) => {
    promise = promise.then((success) => {
      let ECONNABORTED = false;
      const syncAll = () => {
        let promise = Promise.resolve(true);
        if ([Region.name].includes(initialSyncAllModel.name)) {
          promise = initialSyncAllModel.syncAll({}, [], true, (p) => {
            progresses[index] = p;
            if (onSyncProgressUpdate) {
              onSyncProgressUpdate(_.sum(progresses) / total, total, _.sum(progresses) / 100 / total);
            }
          }, (error) => {
            if (error.code === 'ECONNABORTED') ECONNABORTED = true
            if (onError) onError(error);
            return false;
          })
        } else {
          const data = bulkData[initialSyncAllModel.name]
          promise = initialSyncAllModel.syncAllPopulate(
            { type: 1 },
            { data: { data, meta: { total: data.length } } },
            [],
            timestamp,
            (p) => {
              progresses[index] = p;
              if (onSyncProgressUpdate) {
                onSyncProgressUpdate(_.sum(progresses) / total, total, _.sum(progresses) / 100 / total);
              }
            },
          ).then(() => true).catch((error) => {
            if (error.code === 'ECONNABORTED') ECONNABORTED = true
            if (onError) onError(error);
            return false;
          })
        }
        return promise.then((s) => {
          if (!s && ECONNABORTED) return syncAll()
          return s
        })
      }
      return success && syncAll()
    });
  });

  return promise.then((success) => {
    if (success && onSyncProgressUpdate) onSyncProgressUpdate(100);
    return success
  }).finally(() => {
    SyncableModel.allowReplaceUpdate = false
  });
}

// export function initialSyncAllSemiParallel(
//   onSyncProgressUpdate = undefined, onError = undefined
// ) {
//   let promise = Promise.resolve(true);
//   SyncableModel.allowReplaceUpdate = true;
//   const progresses = [];
//   const resolved = [];
//   const total = initialSyncAllModels.length;
//   initialSyncAllModels.forEach((initialSyncAllModel, index) => {
//     promise = promise.then((success) => (new Promise<boolean>((resolve) => {
//       console.log(`Start Sync ${initialSyncAllModel.name}`);
//       const value = success && initialSyncAllModel.syncAll({}, [], true, (p) => {
//         if (p === 1) {
//           // console.log(`Finish Fetch ${initialSyncAllModel.name}`);
//           if (index === 0) resolve(true);
//           else if (index === (initialSyncAllModels.length - 1))
//             resolve(Promise.resolve(resolved[index - 1]).then(() => Promise.resolve(resolved[index])))
//           else resolve(resolved[index - 1])
//         }
//         progresses[index] = p;
//         if (onSyncProgressUpdate) {
//           onSyncProgressUpdate(_.sum(progresses) / total, total, _.sum(progresses) / 100 / total);
//         }
//       },  (error) => {
//         if (onError) onError(error);
//         return resolve(false);
//       }).finally(() => {
//         console.log(`Finished Sync ${initialSyncAllModel.name}`);
//       })
//       resolved.push(value)
//     })))
//   });
//   console.log(new Date())
//   return promise.then((success) => {
//     if (success && onSyncProgressUpdate) onSyncProgressUpdate(100);
//     return success
//   }).finally(() => {
//     SyncableModel.allowReplaceUpdate = false
//     console.log(new Date())
//   });
// }

export const canBePushedModels = [
  Farm,
  FarmParameter,
  Pond,
  AutoFeederPond,
  Cycle,
  Measurement,
  Treatment,
  Feed,
  Fasting,
  Sampling,
  Harvest,
  Mortality,
  CycleDisease,
  File,
  Product,
  Stock,
  FeedingTrayControl
];

export const canBeResetModels = [
  ...canBePushedModels,
  FarmUser,
  CycleActual,
  CyclePrediction,
  User
];

export function canBePushedCount() {
  let promise = Promise.resolve(0);
  canBePushedModels.forEach((canBePushedModel) => {
    promise = promise.then(async (c) => {
      const query = canBePushedModel.query().withoutGlobalScopes() as unknown as typeof SyncableModel
      return (await query.canBePushed().count()) + c;
    });
  });
  return promise;
}

export function canBePushedPushAll(
  checkParent = true,
  onPushProgressUpdate = undefined, onError = undefined
) {
  let promise = Promise.resolve(null);
  const progresses = [];
  const total = canBePushedModels.length;
  canBePushedModels.forEach((canBePushedModel, index) => {
    promise = promise.then(() => canBePushedModel.pushAll([], checkParent, (p) => {
      progresses[index] = p === null ? 100 : p;
      if (onPushProgressUpdate) {
        onPushProgressUpdate(_.sum(progresses) / total, total, _.sum(progresses) / 100 / total);
      }
    }, (error) => {
      if (onError) onError(error);
    }));
  });
  return promise.finally(() => {
    if (onPushProgressUpdate) onPushProgressUpdate(null);
  });
}

export function canBePushedSyncAll(
  onPushProgressUpdate = undefined, onError = undefined
) {
  let promise = Promise.resolve(null);
  const progresses = [];
  const total = canBePushedModels.length;
  canBePushedModels.forEach((canBePushedModel, index) => {
    promise = promise.then(() => {
      const query = canBePushedModel.query() as unknown as typeof SyncableModel
      query.canBePushed().get()
        .then((models) => {
          let promiseModel = Promise.resolve(null);
          models.forEach((model: SyncableModel) => {
            promiseModel = promiseModel.then(() => model.sync())
              .catch((error) => {
                if (onError) onError(error);
              });
          });
          return promiseModel;
        })
        .then(() => {
          progresses[index] = 100;
          if (onPushProgressUpdate) {
            onPushProgressUpdate(_.sum(progresses) / total, total, _.sum(progresses) / 100 / total);
          }
        }, (error) => {
          if (onError) onError(error);
        })
    });
  });
  return promise.finally(() => {
    if (onPushProgressUpdate) onPushProgressUpdate(null);
  });
}

export function resetDatabase() {
  let promise = Promise.resolve(null);
  canBeResetModels.reverse().forEach((canBeResetModel) => {
    promise = promise.then(() => canBeResetModel.query().getQuery().delete())
      .catch(() => false);
  });
  return promise;
}
